import React from "react";
import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import ReactTable from "react-table";
import moment from "moment";
import {Card, CardContent} from "@material-ui/core";
import ReportDateToolbar, {
	buildReportApiFilter,
	createDefaultReportDateState,
	defaultReportFilterState,
	formatDateRangeLabel,
} from "components/Elements/ReportFilterToggles";

const DATE_STORAGE_KEY = "dateTaxableBreakdown";

export default class TaxableBreakdownReports extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Locations_Sales._name, API.RequestType.READ_ALL);
		super(props, model);
		Object.assign(this.state, defaultReportFilterState, createDefaultReportDateState(DATE_STORAGE_KEY));
	}

	handleLayawayModeChange = async (completedLayawaysOnly) => {
		await this.setState({completedLayawaysOnly});
		await this.getReport();
	};

	handleWorkOrderModeChange = async (completedWorkOrdersOnly) => {
		await this.setState({completedWorkOrdersOnly});
		await this.getReport();
	};

	handleTimezoneModeChange = async (useLocalTimezone) => {
		await this.setState({useLocalTimezone});
		await this.getReport();
	};

	async componentDidMount() {
		await this.getReport();
	}

	handleToggleModal = (modal) => {
		this.setState({[modal]: !this.state[modal]});
	};

	handleDateChange = async (name, date) => {
		await this.setState({filterDate: moment(date).format()});
		this.handleToggleModal("showDate");
		await this.getReport();
	};

	handleCancelDateRange = () => {
		const today = moment().format("YYYY-MM-DD");
		this.setState({start_date: today, end_date: today});
		this.handleToggleModal("showDateRange");
	};

	getReport = async () => {
		await this.setState({loading: true});
		try {
			let model = new API.BuildClass(Types.Locations_Sales._name, API.RequestType.READ);
			this.read = "GET_TAXABLE_BREAKDOWN";
			model.filter = buildReportApiFilter(this.state);
			this.state.filter = model.filter;
			const dateRangeFormatted = formatDateRangeLabel(
				this.state.start_date,
				this.state.end_date
			);
			model.search = this.state.search;
			this.data = await model.submit(null, this.read);
			this.data = this.data.items || [];
			await this.setState({data: this.data, dateRangeFormatted});
			localStorage.setItem(DATE_STORAGE_KEY, this.state.filterDate);
		} finally {
			await this.setState({loading: false});
		}
	};

	render() {
		const {data, pages, loading, limit} = this.state;
		let columns = [
			{
				Header: "Group",
				id: "group_name",
				accessor: (r) => r?.group_name ?? "",
				sortable: false,
			},
			{
				Header: "Tax Rate %",
				id: "tax_rate",
				className: 'center-column',
				accessor: (r) => (r?.tax_rate != null ? `${parseFloat(r.tax_rate).toFixed(4)}%` : ""),
				sortable: false,
			},
			{
				Header: "Taxable Base",
				id: "taxable_base",
				className: 'center-column',
				accessor: (r) => "$" + (r?.taxable_base ?? "0.00"),
				sortable: false,
			},
			{
				Header: "Tax Collected",
				id: "tax_amount",
				className: 'center-column',
				accessor: (r) => "$" + (r?.tax_amount ?? "0.00"),
				sortable: false,
			},
		];

		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<ReportDateToolbar
							filterDate={this.state.filterDate}
							start_date={this.state.start_date}
							end_date={this.state.end_date}
							dateRangeFormatted={this.state.dateRangeFormatted}
							showDate={this.state.showDate}
							showStartDate={this.state.showStartDate}
							showEndDate={this.state.showEndDate}
							showDateRange={this.state.showDateRange}
							onToggleModal={this.handleToggleModal}
							onSingleDateChange={this.handleDateChange}
							onStartDateChange={(start_date) => this.setState({start_date})}
							onEndDateChange={(end_date) => this.setState({end_date})}
							onApplyDateRange={this.getReport}
							onCancelDateRange={this.handleCancelDateRange}
							toggleClose={this.toggleClose}
							completedLayawaysOnly={this.state.completedLayawaysOnly}
							completedWorkOrdersOnly={this.state.completedWorkOrdersOnly}
							useLocalTimezone={this.state.useLocalTimezone}
							onLayawayModeChange={this.handleLayawayModeChange}
							onWorkOrderModeChange={this.handleWorkOrderModeChange}
							onTimezoneModeChange={this.handleTimezoneModeChange}
						/>
					</div>
					{!loading && (!data || data.length === 0) ? (
						<div>There is no data for the dates selected.</div>
					) : (
						<ReactTable
							columns={columns}
							data={data || []}
							pages={pages}
							loading={loading}
							loadingText="Requesting Data"
							defaultSorted={[
								{
									id: this.model.sort,
									desc: this.model.order === "ascending",
								},
							]}
							className="-striped -highlight"
							showPaginationTop={false}
							showPaginationBottom={false}
							showPageSizeOptions={true}
							defaultPageSize={limit || 50}
						/>
					)}
					<Framework.Elements.LoadingSpinner isLoading={loading} />
				</CardContent>
			</Card>
		);
	}
}
